// =======================
// Stable Swiper + Variant + Zoom (Buddy😎 Final Edition)
// - Same structure preserved
// - All functionalities active
// - Optimized for Shopify
// =======================

(function () {
    "use strict";
    console.log("🚀 Script loaded successfully!");
    function syncMainThumbnails(activeIndex) {
        const thumbs = document.querySelectorAll(
            ".product__media-sublist img, .product__media-thumbnail"
        );

        thumbs.forEach((thumb, i) => {
            thumb.classList.toggle("is-active", i === activeIndex);
        });
    }

    const swiperByEl = new WeakMap();
    const thumbnailByEl = new WeakMap();
    let lastIsMobile = null;
    let resizeTimer;
    let variantTimer;
    let lastSwatchValue = null;

    function formatShopifyMoney(cents) {
        const value = Math.round(cents / 100); // remove decimal
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: Shopify.currency?.active || 'INR',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(value);
    }

    let ayaani_lastActiveSlide = 0; // 🔧 FIX: remember last active swiper slide

    function observeProductMedia() {
        const observer = new MutationObserver(() => {
            const swiperEl = document.querySelector(".product-media-swiper");
            const thumbnailEl = document.querySelector(".product-media-swiper-thumbs");

            if (
                swiperEl?.querySelector(".swiper-wrapper") &&
                thumbnailEl?.querySelector(".swiper-wrapper")
            ) {
                initAllSwipers(true);
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }


    // =========================================
    // 🚫 DISABLE SHOPIFY MEDIA-GALLERY SYNC
    // =========================================
    function disableShopifyMediaSync() {
        const mg = document.querySelector("media-gallery");
        if (!mg) return;

        mg.removeAttribute("deferred-media");
        mg.setAttribute("data-disable-media-sync", "true");

        // Stop Shopify from forcing active image change
        mg.setActiveMedia = function () { };
        mg.scrollIntoView = function () { };
    }

    // -----------------------------
    // 🌀 SWIPER (MOBILE ONLY)
    // -----------------------------
    function destroySwiper(el, thumbnail) {
        const inst = swiperByEl.get(el);
        const thumbnailInst = thumbnailByEl.get(thumbnail);

        if (thumbnailInst) thumbnailInst.destroy(true, true);

        if (inst) {
            ayaani_lastActiveSlide = inst.activeIndex || 0;
            inst.destroy(true, true);
        }

        el.classList.remove("swiper-initialized"); // optional safety
        swiperByEl.delete(el);
        thumbnailByEl.delete(thumbnail);

    }



    function initSwiper(el, thumbnail) {
        if (!el || !thumbnail) return;

        if (!el.classList.contains("swiper")) el.classList.add("swiper");
        if (!thumbnail.classList.contains("swiper")) thumbnail.classList.add("swiper");

        let pag = el.querySelector(".mobile-product-media-pagination");
        if (!pag) {
            pag = document.createElement("div");
            pag.className = "mobile-product-media-pagination";
            el.appendChild(pag);
        }

        if (!document.getElementById("swiper-pagination-styles")) {
            const style = document.createElement("style");
            style.id = "swiper-pagination-styles";
            style.textContent = `
        .mobile-product-media-pagination{position:absolute;display:flex;justify-content:center;align-items:center;margin-top:15px;padding:8px 0;gap:6px;z-index:10}
        .swiper-pagination-bullet{width:4px;height:4px;border-radius:50%;background:rgba(0,0,0,.2);margin:0!important;transition:all .3s cubic-bezier(.4,0,.2,1);cursor:pointer;border:none;outline:none;padding:0;opacity:.6}
        .swiper-pagination-bullet-active{width:20px;height:6px;border-radius:9999px;background:#000;opacity:1}
        .swiper-pagination-bullet.is-near-1{width:8px;height:8px;opacity:.8}
        .swiper-pagination-bullet.is-near-2{width:6px;height:6px;opacity:.7}
        .swiper-pagination-bullet:hover{opacity:1;transform:scale(1.1)}
        .swiper-pagination-bullet-active:hover{transform:none}`;
            document.head.appendChild(style);
        }

        const thumbnailInst = new Swiper(thumbnail, {
            loop: false,
            slidesPerView: 3.5,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            watchSlidesProgress: true,
            speed: 300,
        });

        const inst = new Swiper(el, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            speed: 300,
            thumbs: {
                swiper: thumbnailInst
            },
            pagination: {
                el: pag,
                clickable: true,
                type: "bullets",
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
                renderBullet(index, className) {
                    return `<span class="${className}" data-index="${index}"></span>`;
                },
            },
            on: {
                init() {

                    // ✅ RESTORE LAST ACTIVE SLIDE (🔥 FIX)
                    if (
                        typeof ayaani_lastActiveSlide === "number" &&
                        ayaani_lastActiveSlide > 0 &&
                        ayaani_lastActiveSlide < this.slides.length
                    ) {
                        this.slideTo(ayaani_lastActiveSlide, 0, false);
                    }

                    // show swiper AFTER correct slide is set
                    el.classList.remove("swiper--pending");
                    el.style.opacity = "1";
                    el.style.visibility = "visible";

                    this.updatePaginationClasses = () => {
                        const bullets = Array.from(this.pagination.bullets || []);
                        const activeIndex = this.activeIndex;
                        bullets.forEach((b, i) => {
                            const dist = Math.abs(i - activeIndex);
                            b.classList.toggle("is-near-1", dist === 1);
                            b.classList.toggle("is-near-2", dist === 2);
                        });
                    };

                    this.updatePaginationClasses();

                    setTimeout(() => {
                        initCustomZoom(el);
                    }, 0);
                },
                slideChange() {
                    ayaani_lastActiveSlide = this.activeIndex; // 🔥 VERY IMPORTANT
                    if (this.updatePaginationClasses) this.updatePaginationClasses();
                    syncMainThumbnails(this.activeIndex);
                },
            },

        });


        swiperByEl.set(el, inst);
        thumbnailByEl.set(thumbnail, thumbnailInst);
    }

    function initAllSwipers(force = false) {
        disableShopifyMediaSync();

        const isMobile = window.innerWidth <= 789;
        if (!force && lastIsMobile === isMobile) return;

        document.querySelectorAll(".product-media-swiper").forEach((el) => {
            if (!el.isConnected) return;

            const parent = el.parentElement;
            const thumbnail =
                parent?.querySelector(".product-media-swiper-thumbs") ||
                    el.nextElementSibling?.matches(".product-media-swiper-thumbs")
                    ? el.nextElementSibling
                    : null;

            if (!thumbnail) {
                console.warn("Thumb swiper not found for", el);
                return;
            }

            if (isMobile) {
                destroySwiper(el, thumbnail);
                initSwiper(el, thumbnail);
            } else {
                destroySwiper(el, thumbnail);
            }
        });

        lastIsMobile = isMobile;
    }

    // -----------------------------
    // 🧬 VARIANT CHANGE HANDLER
    // -----------------------------
    // ⚡ INSTANT UPDATE — price + form (no API, no delay)
    // -----------------------------
    function processVariantFast() {
        const fieldsets = document.querySelectorAll(".product__info-wrapper fieldset");
        if (!fieldsets.length) return;
        if (typeof p_variants === "undefined" || !p_variants.length) return;

        const selectedValues = Array.from(fieldsets)
            .map((fs) => fs.querySelector("input:checked"))
            .filter(Boolean)
            .map((i) => i.value);
        const selectedVariant = [...new Set(selectedValues)].join(" / ");
        if (!selectedVariant) return;

        const variant = p_variants.find((v) => v.title === selectedVariant);
        if (!variant) return;

        // Form hidden input
        document.querySelectorAll('input[name="id"]').forEach(function (input) {
            input.value = variant.id;
        });

        // URL
        if (window.history && window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
        }

        // Price display
        const priceWrapper = document.querySelector('[id^="price-"]');
        if (priceWrapper) {
            const price = variant.price;
            const comparePrice = variant.compare_at_price;
            const isOnSale = comparePrice && comparePrice > price;
            priceWrapper.classList.toggle('price--on-sale', !!isOnSale);
            priceWrapper.classList.toggle('price--sold-out', !variant.available);
            const formattedPrice = formatShopifyMoney(price);
            const regularEl = priceWrapper.querySelector('.price__regular .price-item--regular');
            if (regularEl) regularEl.textContent = formattedPrice;
            const saleEl = priceWrapper.querySelector('.price__sale .price-item--sale');
            if (saleEl) saleEl.textContent = formattedPrice;
            if (isOnSale) {
                const compareEl = priceWrapper.querySelector('.price__sale s.price-item--regular');
                if (compareEl) compareEl.textContent = formatShopifyMoney(comparePrice);
                const badgeEl = priceWrapper.querySelector('.price__badge-sale');
                if (badgeEl) {
                    const pct = Math.round((comparePrice - price) * 100 / comparePrice);
                    badgeEl.textContent = pct + '% Off';
                }
            }
        }
    }

    // -----------------------------
    function processVariantCustom() {
        const moneyFormat = window.Shopify?.money_format || "{{ shop.money_format }}";
        const infoWrapper = document.querySelector(".product__info-wrapper");
        const productHandle = infoWrapper?.getAttribute("data-product-handle");
        if (!infoWrapper) { console.error("❌ STOP: .product__info-wrapper not found"); return; }

        const swatch = document.querySelector('.product__info-wrapper .swatch-input__input:checked');
        const currentSwatch = swatch ? swatch.value : null;

        const shouldUpdateImages = currentSwatch !== lastSwatchValue;
        lastSwatchValue = currentSwatch;

        const fieldsets = document.querySelectorAll("fieldset");
        const selectedValues = Array.from(fieldsets)
            .map((fs) => fs.querySelector("input:checked"))
            .filter(Boolean)
            .map((i) => i.value);

        const uniqueValues = [...new Set(selectedValues)];
        const selectedVariant = uniqueValues.join(" / ");
        console.error("✅ selectedVariant:", selectedVariant);
        if (!selectedVariant) { console.error("❌ STOP: selectedVariant is empty"); return; }

        const wishlistBtn = infoWrapper.querySelector(".wishlist_button");

        if (typeof p_variants === "undefined") { console.error("❌ STOP: p_variants is undefined"); return; }
        if (!p_variants.length) { console.error("❌ STOP: p_variants is empty array"); return; }
        console.error("✅ p_variants count:", p_variants.length);
        const variantSku = p_variants[0].sku;
        const variantValue = variantSku.replace(/\s/g, '%20');
        const variant = p_variants.find((v) => v.title === selectedVariant);
        console.error("✅ variant found:", variant ? variant.title : "NOT FOUND — p_variants titles:", p_variants.map(v => v.title));
        if (!variant) { console.error("❌ STOP: variant not found for title:", selectedVariant); return; }

        // Shopify product form ka hidden variant ID update karo (AJAX re-render band hai isliye manually)
        document.querySelectorAll('input[name="id"]').forEach(function (input) {
            input.value = variant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        // Browser URL me variant ID update karo
        if (window.history && window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
        }

        // Main price display update karo (AJAX band hai isliye manually)
        (function () {
            const priceWrapper = document.querySelector('[id^="price-"]');
            if (!priceWrapper) return;

            const price = variant.price;
            const comparePrice = variant.compare_at_price;
            const isOnSale = comparePrice && comparePrice > price;

            priceWrapper.classList.toggle('price--on-sale', !!isOnSale);
            priceWrapper.classList.toggle('price--sold-out', !variant.available);

            const formattedPrice = formatShopifyMoney(price);
            const formattedCompare = comparePrice ? formatShopifyMoney(comparePrice) : null;

            // Regular price (sale nahi hai tab)
            const regularEl = priceWrapper.querySelector('.price__regular .price-item--regular');
            if (regularEl) regularEl.textContent = formattedPrice;

            // Sale price (main amount)
            const saleEl = priceWrapper.querySelector('.price__sale .price-item--sale');
            if (saleEl) saleEl.textContent = formattedPrice;

            // Compare at price (strikethrough)
            const compareEl = priceWrapper.querySelector('.price__sale s.price-item--regular');
            if (compareEl && formattedCompare) compareEl.textContent = formattedCompare;

            // Discount badge percentage
            if (isOnSale) {
                const badgeEl = priceWrapper.querySelector('.price__badge-sale');
                if (badgeEl) {
                    const discountPct = Math.round((comparePrice - price) * 100 / comparePrice);
                    badgeEl.textContent = discountPct + '% Off';
                }
            }
        })();

        const currentColor = variant.option1;
        const gold_metal_pi = document.getElementById('gold_metal_pi');
        const gold_weight_pi = document.getElementById('gold_weight_pi');
        const diamond_type_pi = document.getElementById('diamond_type_pi');
        const diamond_weight_pi = document.getElementById('diamond_weight_pi');
        const solitaire_type_pi = document.getElementById('solitaire_type_pi');
        const solitaire_weight_pi = document.getElementById('solitaire_weight_pi');
        const product_weight_pi = document.getElementById('product_weight_pi');
        const product_discount_text = document.getElementById('product_discount_text');
        const discount_text = document.getElementById('discount_text');
        const option1 = variant.option1
        const colorValue = option1?.replace(/\s/g, '-').toLowerCase();
        console.error("✅ SKU:", variant.sku, "| option1:", option1, "| colorValue:", colorValue);
        let colorIndex = 0;
        if (colorValue === '18kt-gold-vermeil') colorIndex = 1;
        if (colorValue === 'rose-gold') colorIndex = 1;
        if (colorValue === 'yellow-gold') colorIndex = 2;
        if (colorValue === 'white-gold') colorIndex = 3;
        const kt = variant.option2;
        const size = colorValue === '18kt-gold-vermeil' ? variant.option2 : variant.option3;
        console.error("✅ kt:", kt, "| size:", size, "| colorIndex:", colorIndex);
        let apiURL = "";
        if (colorValue === '18kt-gold-vermeil') {
             if (gold_metal_pi) gold_metal_pi.textContent = `${option1}`;
        }
        else {
            if (gold_metal_pi)
                kt ? gold_metal_pi.textContent = `${kt} ${option1}` : gold_metal_pi.textContent = option1;
        }
        if (product_discount_text) product_discount_text.classList.add("loading-product");
        if (colorValue === '18kt-gold-vermeil') {
            if (size) {
                apiURL += `https://ecom-api.ayaani.app/api/Product/Get_ECom_Product_Dtls_PriceChange_SKUWise?SKU=${variantValue}&color=4&Kt=18kt&size=${size}&Is_FullPriceBreakup=false`;
            } else {
                apiURL += `https://ecom-api.ayaani.app/api/Product/Get_ECom_Product_Dtls_PriceChange_SKUWise?SKU=${variantValue}&color=4&Kt=18kt&Size=0&Is_FullPriceBreakup=false`;
            }
        } else {
            if (size) {
                apiURL += `https://ecom-api.ayaani.app/api/Product/Get_ECom_Product_Dtls_PriceChange_SKUWise?SKU=${variantValue}&color=${colorIndex}&Kt=${kt}&size=${size}&Is_FullPriceBreakup=true`;
            } else {
                apiURL += `https://ecom-api.ayaani.app/api/Product/Get_ECom_Product_Dtls_PriceChange_SKUWise?SKU=${variantValue}&color=${colorIndex}&Kt=${kt}&Size=0&Is_FullPriceBreakup=true`;
            }
        }
        console.error("✅ API URL:", apiURL);

        fetch(apiURL)
            .then((res) => {
                if (!res.ok) {
                    throw new Error("API response not OK");
                }
                return res.json();
            })
            .then((data) => {
                let isGold = false;
                let goldTable = "";
                let goldRows = "";
                let gold_final_value = "";
                let isDiamond = false;
                let diamondTable = "";
                let diamondRows = "";
                let total_diamond_final_value = "";
                let totalDiamondValue = 0;
                let is_stone = false;
                let stoneTable = "";
                let stoneRows = "";
                let total_stone_final_value = "";
                let totalStoneValue = 0;
                let is_lbr = false;
                let lbrTable = "";
                let labourRow = "";
                let total_lbr_final_value = "";
                let totalLbrValue = 0;
                let is_SubTotal = false;
                let subTotalTable = "";
                let subtotalRow = "";
                let is_tax = false;
                let taxTable = "";
                let taxRow = "";
                let is_grandTotal = false;
                let grandTotalTable = "";
                let grandtotalRow = "";


                data.PriceBreakup?.forEach((item) => {
                    if (item.MaterialType_Code === "M") {
                        isGold = true;
                        const formattedGoldRate = formatShopifyMoney(item.Rate * 100);
                        const formattedGoldFinalValue = formatShopifyMoney(item.Final_Value * 100);
                        const goldRate = `${formattedGoldRate}/g`;
                        const gold_weight = `${item.Weight} g`;
                        gold_final_value = formattedGoldFinalValue;
                        goldRows += `
                            <tr class="undefined Product_Detail_accordion_cell_one__G9OB_">
                                <td class="Product_Detail_accordion_goldText__0A65d">
                                    <div class="Product_Detail_accordion_subText__L2_Iy">
                                      <span class="product_metal">${kt}</span><span class="product_color">
                                        ${option1}</span
                                      >
                                    </div>
                                  </td>
                                  <td class="mt-2 Product_Detail_accordion_cell__l4CtN">
                                    <span class="gold_rate">${goldRate}</span>
                                  </td>
                                  <td class="Product_Detail_accordion_cell__l4CtN ">
                                    <span class="gold_weight" id="gold_weight">${gold_weight}</span>
                                    &nbsp;<span class="Product_Detail_accordion_infoIcon__7BLWB"
                                      ><i class="fa-solid fa-circle-info"></i>
                                    </span>
                                  </td>
                                  <td class="Product_Detail_accordion_cell__l4CtN">
                                    <span class="gold_final_value" id="gold_final_value">${formattedGoldFinalValue}</span
                                    ><span
                                      class="Product_Detail_accordion_old_price__uegdB"
                                    ></span>
                                </td>
                            </tr>
                        `;
                    }
                    if (item.MaterialType_Code === "D") {
                        isDiamond = true;
                        let formattedDiamondFinalValue = formatShopifyMoney(item.Final_Value * 100);
                        let diamond_final_value = formattedDiamondFinalValue;

                        let formattedDiamondOldValue = formatShopifyMoney(item.Value * 100);
                        let diamond_old_value = formattedDiamondOldValue;

                        totalDiamondValue += Number(item.Final_Value);

                        let formattedTotalDiamondFinalValue = formatShopifyMoney(totalDiamondValue * 100);
                        total_diamond_final_value = formattedTotalDiamondFinalValue;

                        let hasDaimondDiscount = "";

                        if (item.Final_Value < item.Value) {
                            hasDaimondDiscount += `
                                <span
                                      class="Product_Detail_accordion_final_price__uM3cM diamond_final_value"
                                      id="diamond_final_value"
                                      >${diamond_final_value}</span
                                    ><span
                                      class="Product_Detail_accordion_old_price__uegdB diamond_old_value"
                                      id="diamond_old_value"
                                      >${diamond_old_value}</span
                                    >
                            `;
                        } else {
                            hasDaimondDiscount += `
                                 <span
                                      class="Product_Detail_accordion_final_price__uM3cM diamond_final_value"
                                      id="diamond_final_value"
                                      >${diamond_final_value}</span
                                    >
                            `;
                        }

                        diamondRows += `
                            <tr class="undefined Product_Detail_accordion_cell_one__G9OB_">
                                  <td class="Product_Detail_accordion_goldText__0A65d">
                                    <div class="Product_Detail_accordion_subText__L2_Iy" id="diamond1">
                                      ${item.Component}
                                    </div>
                                  </td>
                                  <td class="mt-2 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="Product_Detail_accordion_cell__l4CtN ">
                                    <span class="diamond_weight" id="diamond_weight">${item.Weight} ct</span>
                                    &nbsp;<span class="Product_Detail_accordion_infoIcon__7BLWB"
                                      ><i class="fa-solid fa-circle-info"></i>
                                    </span>
                                  </td>
                                  <td class="Product_Detail_accordion_cell__l4CtN undefined">
                                    ${hasDaimondDiscount}
                                  </td>
                                </tr>
                        `;
                        console.log(total_diamond_final_value);
                    }
                    if (item.MaterialType_Code === "ST") {
                        is_stone = true
                        let formattedStoneFinalValue = formatShopifyMoney(item.Final_Value * 100);
                        let store_final_value = formattedStoneFinalValue;
                        let formattedStoneOldValue = formatShopifyMoney(item.Value * 100);
                        let store_Old_value = formattedStoneOldValue;

                        totalStoneValue += Number(item.Final_Value);

                        let formattedTotalStoneFinalValue = formatShopifyMoney(totalStoneValue * 100);
                        total_stone_final_value = formattedTotalStoneFinalValue;
                        let hasStoneDiscount = "";

                        if (item.Final_Value < item.Value) {
                            hasStoneDiscount += `
                                <span
                                      class="Product_Detail_accordion_final_price__uM3cM diamond_final_value"
                                      id="diamond_final_value"
                                      >${store_final_value}</span
                                    ><span
                                      class="Product_Detail_accordion_old_price__uegdB diamond_old_value"
                                      id="diamond_old_value"
                                      >${store_Old_value}</span
                                    >
                            `;
                        } else {
                            hasStoneDiscount += `
                                 <span
                                      class="Product_Detail_accordion_final_price__uM3cM diamond_final_value"
                                      id="diamond_final_value"
                                      >${store_final_value}</span
                                    >
                            `;
                        }
                        stoneRows += `
                            <tr class="undefined Product_Detail_accordion_cell_one__G9OB_">
                                  <td class="Product_Detail_accordion_goldText__0A65d">
                                    <div class="Product_Detail_accordion_subText__L2_Iy" id="diamond1">
                                      ${item.Component}
                                    </div>
                                  </td>
                                  <td class="mt-2 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="Product_Detail_accordion_cell__l4CtN ">
                                    <span class="diamond_weight" id="diamond_weight">${item.Weight} ct</span>
                                    &nbsp;<span class="Product_Detail_accordion_infoIcon__7BLWB"
                                      ><i class="fa-solid fa-circle-info"></i>
                                    </span>
                                  </td>
                                  <td class="Product_Detail_accordion_cell__l4CtN undefined">
                                    ${hasStoneDiscount}
                                  </td>
                                </tr>
                        `;

                    }
                    if (item.MaterialType_Code === "Lbr") {
                        is_lbr = true
                        let formattedLbrFinalValue = formatShopifyMoney(item.Final_Value * 100);
                        let lbr_final_value = formattedLbrFinalValue;
                        let formattedLbrOldValue = formatShopifyMoney(item.Value * 100);
                        let lbr_old_value = formattedLbrOldValue;

                        totalLbrValue += Number(item.Final_Value);

                        let formattedTotalLbrFinalValue = formatShopifyMoney(totalLbrValue * 100);
                        total_lbr_final_value = formattedTotalLbrFinalValue;

                        let hasLbrDiscount = "";

                        if (item.Final_Value < item.Value) {
                            hasLbrDiscount += `
                                <span
                                      class="Product_Detail_accordion_final_price__uM3cM making_charges_final_value"
                                      id="making_charges_final_value"
                                      >${lbr_final_value}</span
                                    ><span
                                      class="Product_Detail_accordion_old_price__uegdB making_charges_old_value"
                                      id="making_charges_old_value"
                                      >${lbr_old_value}</span
                                    >
                            `;
                        } else {
                            hasLbrDiscount += `
                                 <span
                                      class="Product_Detail_accordion_final_price__uM3cM diamond_final_value"
                                      id="diamond_final_value"
                                      >${lbr_final_value}</span
                                    >
                            `;
                        }

                        labourRow = `
                            <tr class="Product_Detail_accordion_headerRow__iNYIW">
                                  <th class="border-bottom-0 border-0 Product_Detail_accordion_cell__l4CtN">
                                    Making Charges
                                  </th>
                                  <th class="border-bottom-0 Product_Detail_accordion_cell1___Fw6X"><span>-</span></th>
                                  <th class="border-bottom-0 Product_Detail_accordion_cell1___Fw6X"><span>-</span></th>
                                  <th class="border-bottom-0 Product_Detail_accordion_cell__l4CtN">
                                    ${hasLbrDiscount}
                                  </th>
                                </tr>
                        `;

                    }
                });
                data.Totals.forEach((item) => {
                    gold_weight_pi.textContent = item.NetWt;
                    diamond_type_pi.textContent = item.DPcs;
                    diamond_weight_pi.textContent = item.DCtw;
                    solitaire_type_pi.textContent = `${item.STPcs ?? '0'} Stone`;
                    solitaire_weight_pi.textContent = item.STCtw;
                    product_weight_pi.textContent = item.GrossWt;
                    is_SubTotal = true;
                    is_tax = true;
                    is_grandTotal = true
                    let formattedSubTotalFinalValue = formatShopifyMoney(item.Product_Sub_Sale_Amount * 100);
                    let sub_total_final_value = formattedSubTotalFinalValue;
                    let formattedSubTotalOldValue = formatShopifyMoney(item.Product_Sub_Total_Amount * 100);
                    let sub_total_old_value = formattedSubTotalOldValue;
                    let formattedTaxTotalFinalValue = formatShopifyMoney(item.Product_Sale_Tax_Amount * 100);
                    let tax_total_final_value = formattedTaxTotalFinalValue;
                    let formattedTaxTotalOldValue = formatShopifyMoney(item.Product_Total_Tax_Amount * 100);
                    let tax_total_old_value = formattedTaxTotalOldValue;
                    let formattedGrandTotalFinalValue = formatShopifyMoney(item.Product_Sale_Amount * 100);
                    let grand_total_final_value = formattedGrandTotalFinalValue;
                    let formattedGrandTotalOldValue = formatShopifyMoney(item.Product_Total_Amount * 100);
                    let grand_total_old_value = formattedGrandTotalOldValue;
                    let hasSubTotalDiscount = "";
                    let hasTaxDiscount = "";
                    let hasGrandTotalDiscount = "";
                    if (item.Product_Sub_Sale_Amount < item.Product_Sub_Total_Amount) {
                        hasSubTotalDiscount += `
                            <span class="Product_Detail_accordion_final_price__uM3cM">
                                    ${sub_total_final_value}
                                </span>
                                <span class="Product_Detail_accordion_old_price__uegdB">
                                    ${sub_total_old_value}
                                </span>
                        `
                    } else {
                        hasSubTotalDiscount += `
                            <span class="Product_Detail_accordion_final_price__uM3cM">
                                    ${sub_total_final_value}
                                </span>
                        `
                    }
                    if (item.Product_Sale_Tax_Amount < item.Product_Total_Tax_Amount) {
                        hasTaxDiscount += `
                            <span
                                      class="Product_Detail_accordion_final_price__uM3cM tax_final_value"
                                      id="tax_final_value"
                                      >${tax_total_final_value}</span
                                    >
                                    
                        `
                        // <span
                        //               class="Product_Detail_accordion_old_price__uegdB tax_old_value"
                        //               id="tax_old_value"
                        //               >${tax_total_old_value}</span
                        //             >
                    } else {
                        hasTaxDiscount += `
                             <span
                                      class="Product_Detail_accordion_final_price__uM3cM tax_final_value"
                                      id="tax_final_value"
                                      >${tax_total_final_value}</span
                                    >
                        `
                    }
                    if (item.Product_Sale_Amount < item.Product_Total_Amount) {
                        hasGrandTotalDiscount += `
                            <span
                                      class="Product_Detail_accordion_final_price__uM3cM grand_total_final_value"
                                      id="grand_total_final_value"
                                      >${grand_total_final_value}</span
                                    ><span
                                      class="Product_Detail_accordion_old_price__uegdB grand_total_old_value"
                                      id="grand_total_old_value"
                                      >${grand_total_old_value}</span
                                    >
                        `
                    } else {
                        hasGrandTotalDiscount += `
                             <span
                                      class="Product_Detail_accordion_final_price__uM3cM"
                                      class="grand_total_final_value"
                                      id="grand_total_final_value"
                                      >${grand_total_final_value}</span
                                    >
                        `
                    }
                    subtotalRow += `
                        <tr class="Product_Detail_accordion_totalRow__IZKFS ${sub_total_old_value}">
                            <td class="Product_Detail_accordion_headerRow__iNYIW">Sub Total</td>
                            <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                            <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                            <th class="border-bottom-0 Product_Detail_accordion_cell__l4CtN">
                                ${hasSubTotalDiscount}
                            </th>
                        </tr>
                        `;
                    taxRow += `
                                <tr class="Product_Detail_accordion_headerRow__iNYIW">
                                  <th class="border-bottom-0 Product_Detail_accordion_cell__l4CtN">Tax</th>
                                  <th class="border-bottom-0 Product_Detail_accordion_cell1___Fw6X">-</th>
                                  <th class="border-bottom-0 Product_Detail_accordion_cell1___Fw6X">-</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN undefined border-bottom-0">
                                    ${hasTaxDiscount}
                                  </th>
                                </tr>
                    `;
                    grandtotalRow += `
                        <tr class="Product_Detail_accordion_totalRow__IZKFS">
                                  <td class="Product_Detail_accordion_totalText__5chmK">Grand Total</td>
                                  <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <th class="border-bottom-0 Product_Detail_accordion_cell__l4CtN undefined">
                                    ${hasGrandTotalDiscount}
                                  </th>
                                </tr>
                    `
                });
                if (data?.OfferInfo?.length) {
                    if (discount_text) discount_text.textContent = data.OfferInfo[0].Offer;
                    if (product_discount_text) {
                        product_discount_text.classList.remove("loading-product");
                        product_discount_text.classList.add("active");
                    }
                }
                total_diamond_final_value = formatShopifyMoney(totalDiamondValue * 100);
                total_stone_final_value = formatShopifyMoney(totalStoneValue * 100);
                if (isGold) {
                    goldTable += `<table class="Product_Detail_accordion_goldTable__6Kpai">
                              <thead>
                                <tr class="Product_Detail_accordion_headerRow__iNYIW">
                                  <th class="Product_Detail_accordion_cell__l4CtN">COMPONENT</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">RATE</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">WEIGHT</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">FINAL VALUE</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="undefined Product_Detail_accordion_cell_one__G9OB_">
                                  <td class="border-bottom-0 Product_Detail_accordion_goldText__0A65d">
                                    <span class="Product_Detail_accordion_goldLink__BlbXi">Gold</span>
                                  </td>
                                  <td class="mt-2 border-bottom-0 Product_Detail_accordion_cell__l4CtN"></td>
                                  <td class="border-bottom-0 Product_Detail_accordion_cell__l4CtN "></td>
                                  <td class="border-bottom-0 Product_Detail_accordion_cell__l4CtN"></td>
                                </tr>
                                ${goldRows}

                                <tr class="Product_Detail_accordion_totalRow__IZKFS">
                                  <td class="Product_Detail_accordion_totalText__5chmK">Total Gold Value</td>
                                  <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="Product_Detail_accordion_finalValue__jlmjj">
                                    <span class="total_gold_final_value" id="total_gold_final_value">${gold_final_value}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>`
                }
                if (isDiamond) {
                    diamondTable += ` <table class="Product_Detail_accordion_goldTable__6Kpai">
                              <thead>
                                <tr class="Product_Detail_accordion_headerRow__iNYIW">
                                  <th class="Product_Detail_accordion_cell__l4CtN">COMPONENT</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">RATE</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">WEIGHT</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">FINAL VALUE</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="undefined Product_Detail_accordion_cell_one__G9OB_">
                                  <td class="border-bottom-0 Product_Detail_accordion_goldText__0A65d">
                                    <span class="Product_Detail_accordion_goldLink__BlbXi">Diamond</span>
                                  </td>
                                  <td class="mt-2 border-bottom-0 Product_Detail_accordion_cell__l4CtN"></td>
                                  <td class="border-bottom-0 Product_Detail_accordion_cell__l4CtN "></td>
                                  <td class="border-bottom-0 Product_Detail_accordion_cell__l4CtN"></td>
                                </tr>
                                ${diamondRows}

                                <tr class="Product_Detail_accordion_totalRow__IZKFS">
                                  <td class="pe-0 Product_Detail_accordion_totalText__5chmK">Total Diamond Value</td>
                                  <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="Product_Detail_accordion_finalValue__jlmjj">
                                    <span class="total_diamond_final_value" id="total_diamond_final_value">${total_diamond_final_value}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>`
                }

                if (is_stone) {
                    stoneTable += `
                            <table class="Product_Detail_accordion_goldTable__6Kpai">
                              <thead>
                                <tr class="Product_Detail_accordion_headerRow__iNYIW">
                                  <th class="Product_Detail_accordion_cell__l4CtN">COMPONENT</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">RATE</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">WEIGHT</th>
                                  <th class="Product_Detail_accordion_cell__l4CtN">FINAL VALUE</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="undefined Product_Detail_accordion_cell_one__G9OB_">
                                  <td class="border-bottom-0 Product_Detail_accordion_goldText__0A65d">
                                    <span class="Product_Detail_accordion_goldLink__BlbXi">Stone</span>
                                  </td>
                                  <td class="mt-2 border-bottom-0 Product_Detail_accordion_cell__l4CtN"></td>
                                  <td class="border-bottom-0 Product_Detail_accordion_cell__l4CtN "></td>
                                  <td class="border-bottom-0 Product_Detail_accordion_cell__l4CtN"></td>
                                </tr>
                                ${stoneRows}

                                <tr class="Product_Detail_accordion_totalRow__IZKFS">
                                  <td class="pe-0 Product_Detail_accordion_totalText__5chmK">Total Stone Value</td>
                                  <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="border-0 Product_Detail_accordion_cell__l4CtN"><span>-</span></td>
                                  <td class="Product_Detail_accordion_finalValue__jlmjj">
                                    <span class="total_diamond_final_value" id="total_diamond_final_value">${total_stone_final_value}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                        `
                }
                if (is_lbr) {
                    lbrTable += `
                        <table class="Product_Detail_accordion_goldTable__6Kpai Product_Detail_accordion_total_Table__s1UXP">
                              <thead>
                                ${labourRow}
                              </thead>
                            </table>
                    `
                }
                if (is_SubTotal) {
                    subTotalTable += `
                        <table class="overflow-hidden Product_Detail_accordion_goldTable__6Kpai Product_Detail_accordion_total_Table__s1UXP">
                            <tbody>
                                ${subtotalRow}
                            </tbody>
                        </table>
                        `;
                }
                if (is_tax) {
                    taxTable += `
                        <table class="Product_Detail_accordion_goldTable__6Kpai Product_Detail_accordion_total_Table__s1UXP">
                              <thead>
                                ${taxRow}
                              </thead>
                            </table>
                    `
                }
                if (is_grandTotal) {
                    grandTotalTable += `
                        <table class="overflow-hidden  Product_Detail_accordion_goldTable__6Kpai Product_Detail_accordion_total_Table__s1UXP">
                              <tbody>
                                ${grandtotalRow}
                              </tbody>
                            </table>
                    `
                }
                const row = `
                            ${goldTable}
                            ${diamondTable}
                            ${stoneTable}
                            ${lbrTable}
                            ${subTotalTable}
                            ${taxTable}
                            ${grandTotalTable} `;
                const priceBreakup = document.querySelector(".product_price_breakup");
                if (priceBreakup) priceBreakup.innerHTML = row;
            });


        if (wishlistBtn) {
            wishlistBtn.setAttribute("data-product-variant-id", variant.id);
            wishlistBtn.setAttribute("data-selected-variant-value", variant.option1);
        }

        document
            .querySelectorAll(".stock-label, .estimated-delivery")
            .forEach((e) => (e.style.display = "none"));
        document
            .querySelector(`.stock-label[data-variant-id="${variant.id}"]`)
            ?.style.setProperty("display", "flex");
        document
            .querySelector(`.estimated-delivery[data-variant-id="${variant.id}"]`)
            ?.style.setProperty("display", "block");
        // const priceEl = document.querySelector("#buy-now-price");
        // if (variant.compareAtPriceBuyNow > variant.priceBuyNow) {
        //     priceEl.innerHTML = variant.priceBuyNow;
        // }
        // else {
        //     priceEl.innerHTML = variant.priceBuyNow;
        // }
        if (!shouldUpdateImages) {
            return;
        }


        const grid = document.querySelector(".grid-product-media-list");
        const mediaGallery = document.querySelector("media-gallery");
        if (!grid && !mediaGallery) return;

        // Variant image rebuild logic
        if (variant.variant_image?.length) {
            const gridRef = grid || mediaGallery;
            gridRef.style.opacity = 0;

            setTimeout(() => {
                let html = "";
                let thumbsHTML = "";

                if (window.innerWidth <= 749) {
                    html += '<div class="swiper-wrapper">';
                    thumbsHTML += '<div class="swiper-wrapper">';
                    variant.variant_image.forEach((media, index) => {
                        if (typeof media === "string") {
                            const fetchPriority = index === 0 ? 'fetchpriority="high"' : '';
                            html += `
                <div class="swiper-slide product__media-item grid__item scroll-trigger animate--fade-in swiper-slide-active" role="group" aria-label="1 / 3" style="width: 345px; margin-right: 10px;">
          

                                        <div class="product-media-container media-type-image media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
                                        <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-template--25018520174871__main">

                                        <div class="loading__spinner hidden">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                                        </div>
                                        <div class="product__media media media--transparent">
                                            <img src="${media}" alt="" ${fetchPriority} srcset="${media.replace(/width=\d+/g, 'width=246')} 246w, ${media.replace(/width=\d+/g, 'width=493')} 493w, ${media.replace(/width=\d+/g, 'width=600')} 600w, ${media.replace(/width=\d+/g, 'width=713')} 713w, ${media.replace(/width=\d+/g, 'width=823')} 823w, ${media.replace(/width=\d+/g, 'width=990')} 990w, ${media.replace(/width=\d+/g, 'width=1100')} 1100w, ${media.replace(/width=\d+/g, 'width=1206')} 1206w, ${media.replace(/width=\d+/g, 'width=1346')} 1346w, ${media.replace(/width=\d+/g, 'width=1426')} 1426w, ${media.replace(/width=\d+/g, 'width=1646')} 1646w, ${media.replace(/width=\d+/g, 'width=1946')} 1946w" width="1946" height="2433" loading="lazy" class="image-magnify-hover" sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                                            </div>
                                        </modal-opener></div>

                                                </div>`;
                            thumbsHTML += `<div class="swiper-slide product__media-item grid__item scroll-trigger animate--fade-in">
                                     <img src="${media}" alt="Curved Diamond Wave Ring" width="100%" height="auto">
                                        </div>
                                `;
                        }
                        if (media.media_type === "video" && media.sources) {
                            let videoImage = media.preview_image?.src;
                            html += `<div class="swiper-slide product__media-item grid__item scroll-trigger animate--fade-in swiper-slide-active" role="group" aria-label="1 / 3" style="width: 345px; margin-right: 10px;"><div class="product-media-container media-type-video media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
                                        <div class="product__media media media--transparent">
                                        <deferred-media><video autoplay loop muted playsinline style="aspect-ratio: 1.0; object-fit: cover; width: 100%; height: 100%;">`;
                            media.sources.forEach(source => {
                                if (source.mime_type.includes("video")) {
                                    html += `<source src="${source.url}" type="${source.mime_type}">`;
                                }
                            });
                            console.log(media);
                            html += `Your browser does not support the video tag.</video></deferred-media></div></div></div>`;
                            thumbsHTML += `<div class="swiper-slide product__media-item grid__item scroll-trigger animate--fade-in">
                                     <img src="${videoImage}" alt="Curved Diamond Wave Ring" width="100%" height="auto">
                                        </div>
                                `;
                        }
                    });
                    html += "</div>";


                    thumbsHTML += '</div>';
                    mediaGallery.innerHTML = `<div class="product-media-swiper swiper swiper--pending only-mobile">${html}</div>
                     <div class="product-media-swiper-thumbs swiper">${thumbsHTML}</div>`;
                    setTimeout(() => {
                        initAllSwipers(true);
                        const container = document.querySelector(".product-media-swiper");
                        if (typeof enableZoomOnHover === "function") enableZoomOnHover(2);
                        // if (container) initCustomZoom(container);
                    }, 100);
                } else {
                    variant.variant_image.forEach((media, index) => {
                        if (typeof media === "string") {
                            const fetchPriority = index === 0 ? 'fetchpriority="high"' : '';
                            html += `
                      <li class="grid-product-media-list-item">

                            <div class="product-media-container media-type-image media-fit-fill global-media-settings gradient constrain-height" style="--ratio: 1; --preview-ratio: 1;">
                            <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-template--25018520174871__main">
                                

                            <div class="loading__spinner hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                            </div>
                            <div class="product__media media media--transparent">
                                <img src="${media}?width=1946" alt="" ${fetchPriority} srcset="${media}?width=246 246w, ${media}?width=493 493w, ${media}?width=600 600w, ${media}?width=713 713w, ${media}?width=823 823w, ${media}?width=990 990w, ${media}?width=1100 1100w, ${media}?width=1206 1206w, ${media}?width=1346 1346w, ${media}?width=1426 1426w, ${media}?width=1646 1646w, ${media}?width=1946 1946w" width="1946" height="2433" loading="lazy" class="image-magnify-hover" sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                                </div>
                            </modal-opener></div>

                                    </li>
                      `;
                        } else if (media.media_type === "video" && media.sources) {
                            html += `<li class="grid-product-media-list-item"><div class="product-media-container media-type-image media-fit-fill global-media-settings gradient constrain-height" style="--ratio: 1; --preview-ratio: 1;"><deferred-media><video autoplay loop muted playsinline style="aspect-ratio: 1;object-fit: cover;width: 100%;height: 100%;float: left;">`;
                            media.sources.forEach(source => {
                                if (source.mime_type.includes("video")) {
                                    html += `<source src="${source.url}" type="${source.mime_type}">`;
                                }
                            });
                            html += `</video></deferred-media></div></li>`;
                        }
                    });
                    grid.innerHTML = html;
                    if (typeof enableZoomOnHover === "function") enableZoomOnHover(2);
                    // initCustomZoom(grid);
                }
                gridRef.style.opacity = 1;
            }, 700);
        }
    }

    // -----------------------------
    // 🔍 CUSTOM ZOOM
    // -----------------------------
    class CustomZoom {
        constructor() {
            this.dialog = null;
            this.media = [];
            this.currentIndex = 0;
            this.setup();
        }

        disableParentScroll() {
            this._slideLocked = true;
        }
        enableParentScroll() {
            this._slideLocked = false;
        }



        setup() {
            if (document.getElementById("custom-zoom-dialog")) {
                this.dialog = document.getElementById("custom-zoom-dialog");
                this.thumbs = this.dialog.querySelector("[ref='thumbnails']");
                this.content = this.dialog.querySelector(
                    ".dialog-zoomed-gallery__content"
                );
                return;
            }

            const html = `
        <div id="custom-zoom-dialog" hidden>
          <button class="close-btn" aria-label="Close">&times;</button>
          <div class="dialog-thumbnails-list" ref="thumbnails"></div>
          <div class="dialog-zoomed-gallery__content"></div>
        </div>`;
            document.body.insertAdjacentHTML("beforeend", html);

            const style = document.createElement("style");
            style.textContent = `
        #custom-zoom-dialog{position:fixed;inset:0;background:rgba(0,0,0,0.9);z-index:1000;display:flex;flex-direction:column;align-items:center;justify-content:center}
        #custom-zoom-dialog[hidden]{display:none!important}
        .close-btn{position:absolute;top:15px;right:15px;background:#000;color:#fff;border:none;font-size:24px;cursor:pointer;z-index:1;}
        .dialog-thumbnails-list{position: fixed;bottom: 10px;width: 100%;overflow: auto;left: 0;padding: 10px;display:flex;gap:6px;margin-top:10px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style: none;}
        .dialog-thumbnails-list img{width:60px;height:60px;object-fit:cover;cursor:pointer;opacity:.6;border:2px solid transparent;border-radius:6px;flex: 0 0 60px}
        .dialog-thumbnails-list img.active{opacity:1;border-color:#fff}.dialog-zoomed-gallery__content video{max-width:100%}
        .dialog-zoomed-gallery__content{width:100%;height:auto;display:flex;flex-direction:row;align-items: center}
        .dialog-zoomed-gallery__content > img, .dialog-zoomed-gallery__content > video{flex: 0 0 100%;}
        .dialog-zoomed-gallery__content > video{height: 60vh;object-fit: cover;}
        .dialog-zoomed-gallery__content img{max-width:100%;max-height:auto;object-fit:contain;animation:fadeIn .3s ease}
        .dialog-zoomed-gallery__content::-webkit-scrollbar, .dialog-thumbnails-list::-webkit-scrollbar{height: 0;width: 0;display: none;}
        .zoomable-media {cursor: zoom-in; transition: transform 0.25s ease; transform-origin: center center;}
        .zoomable-media.is-zoomed {cursor: grab;}
        .zoom-slide {
 flex: 0 0 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zoom-pan-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.zoomable-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transform-origin: center center;
  transition: transform 0.25s ease;
  cursor: zoom-in;
}

.zoomable-media.is-zoomed {
  cursor: grab;
}
 .zoom-pan-wrapper { touch-action: pan-x pan-y pinch-zoom; }

.zoomable-media { touch-action: pan-x; }

.zoomable-media.is-zoomed { touch-action: none; }


        @keyframes fadeIn{from{opacity:0}to{opacity:1}}`;
            document.head.appendChild(style);

            this.dialog = document.getElementById("custom-zoom-dialog");
            this.thumbs = this.dialog.querySelector("[ref='thumbnails']");
            this.content = this.dialog.querySelector(".dialog-zoomed-gallery__content");

            this.dialog.querySelector(".close-btn").addEventListener("click", () => this.close());
            this.dialog.addEventListener("click", (e) => {
                if (e.target === this.dialog) this.close();
            });
        }

        open(index, mediaArr) {
            this.media = mediaArr;
            this.currentIndex = index;

            this._opening = true;
            this._ignoreScrollSync = true;

            this.dialog.hidden = false;
            document.body.style.overflow = "hidden";

            // 👇 pass flag
            this.updateDialog(true);

            setTimeout(() => {
                this._opening = false;
                this._ignoreScrollSync = false;
            }, 50);
        }



        close() {
            this.dialog.hidden = true;
            document.body.style.overflow = "";
        }

        updateDialog(isInitialOpen = false) {
            if (!isInitialOpen) return;

            this.content.innerHTML = "";
            this.thumbs.innerHTML = "";

            /* -----------------------------
               🔹 RENDER THUMBNAILS
            ----------------------------- */
            this.media.forEach((m, i) => {
                const thumb = document.createElement("img");
                thumb.src = m.poster || m.src;
                thumb.alt = "";
                thumb.dataset.index = i;

                if (i === this.currentIndex) thumb.classList.add("active");

                thumb.onclick = () => {
                    this.scrollToIndex(i);
                };

                this.thumbs.appendChild(thumb);
            });

            /* -----------------------------
               🔹 RENDER MAIN CONTENT
            ----------------------------- */
            this.media.forEach((m, i) => {
                const slide = document.createElement("div");
                slide.className = "zoom-slide";
                slide.dataset.index = i;

                if (m.type === "image") {
                    const pan = document.createElement("div");
                    pan.className = "zoom-pan-wrapper";

                    const img = document.createElement("img");
                    img.src = m.src;
                    img.className = "zoomable-media";
                    img.dataset.scale = 1;
                    img.dataset.x = 0;
                    img.dataset.y = 0;

                    pan.appendChild(img);
                    slide.appendChild(pan);

                    // ✅ enable zoom ONLY on img
                    this.enableAdvancedZoom(img);

                } else {
                    const video = document.createElement("video");
                    video.src = m.src;
                    video.autoplay = true;
                    video.loop = true;
                    video.muted = true;
                    video.controls = true;
                    video.playsInline = true;
                    video.className = "zoomed-gallery__video";
                    slide.appendChild(video);
                }

                this.content.appendChild(slide);
            });

            /* -----------------------------
               ✅ INSTANT POSITION (NO SCROLL, NO TRAVEL)
            ----------------------------- */
            const target = this.content.querySelector(
                `[data-index="${this.currentIndex}"]`
            );

            if (target) {
                // temporarily disable snap & smooth
                this.content.style.scrollSnapType = "none";
                this.content.style.scrollBehavior = "auto";

                // direct jump
                this.content.style.transition = "none";
                this.content.style.transform = `translateX(-${this.currentIndex * 100}%)`;

                // restore snap behavior
                requestAnimationFrame(() => {
                    this.content.style.transition = "transform 0.35s ease";
                });
            }

            this.setActiveThumb(this.currentIndex);

            /* -----------------------------
               🔁 SCROLL SYNC + SNAP
            ----------------------------- */
            // this.bindScrollSync();
            this.bindSnapScroll();
        }

        enableAdvancedZoom(el) {
            let scale = 1;
            let x = 0;
            let y = 0;
            let startX = 0;
            let startY = 0;
            let startDist = 0;
            let startScale = 1;
            let lastTap = 0;

            const apply = () => {
                const rect = el.getBoundingClientRect();
                const parent = el.parentElement.getBoundingClientRect();

                const maxX = (rect.width - parent.width) / 2;
                const maxY = (rect.height - parent.height) / 2;

                x = Math.max(-maxX, Math.min(x, maxX));
                y = Math.max(-maxY, Math.min(y, maxY));

                el.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
            };


            const reset = () => {
                scale = 1;
                x = 0;
                y = 0;
                el.classList.remove("is-zoomed");
                this.enableParentScroll();
                apply();
                el.style.transform = "translate(0px, 0px) scale(1)";
            };

            el.addEventListener("touchstart", (e) => {
                // 🔥 DOUBLE TAP
                const now = Date.now();
                if (now - lastTap < 300 && e.touches.length === 1) {
                    if (scale > 1) {
                        reset();
                    } else {
                        scale = 2;
                        el.classList.add("is-zoomed");
                        this.disableParentScroll();
                        apply();
                    }
                    e.preventDefault();
                }
                lastTap = now;

                // PINCH START
                if (e.touches.length === 2) {
                    startDist = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY
                    );
                    startScale = scale;
                    this.disableParentScroll();
                }

                // PAN START
                if (e.touches.length === 1 && scale > 1) {
                    startX = e.touches[0].clientX - x;
                    startY = e.touches[0].clientY - y;
                    this.disableParentScroll();
                }
            });

            el.addEventListener("touchmove", (e) => {
                if (e.touches.length === 2) {
                    e.preventDefault();
                    const dist = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY
                    );
                    scale = Math.min(Math.max(startScale * (dist / startDist), 1), 3);
                    el.classList.toggle("is-zoomed", scale > 1);
                    apply();
                    return;
                }

                if (scale > 1 && e.touches.length === 1) {
                    e.preventDefault();
                    x = e.touches[0].clientX - startX;
                    y = e.touches[0].clientY - startY;
                    apply();
                }
            });

            el.addEventListener("touchend", () => {
                if (scale <= 1) reset();
            });
        }



        // ---------- SCROLL TO CONTENT ----------
        scrollToIndex(index) {
            index = Math.max(0, Math.min(index, this.media.length - 1));
            this.currentIndex = index;

            this.content.style.transition = "transform 0.35s ease";
            this.content.style.transform = `translateX(-${index * 100}%)`;

            this.setActiveThumb(index);
            syncMainThumbnails(index);
        }






        // ---------- SET ACTIVE THUMB ----------
        setActiveThumb(index) {
            this.currentIndex = index;

            this.thumbs.querySelectorAll("img").forEach((img, i) => {
                img.classList.toggle("active", i === index);
            });
        }

        // ---------- SCROLL ↔ THUMB SYNC ----------
        bindScrollSync() {
            if (this._scrollBound) return;
            this._scrollBound = true;

            this.content.addEventListener("scroll", () => {
                if (this._opening || this._ignoreScrollSync) return;
                const items = Array.from(this.content.children);
                const contentLeft = this.content.getBoundingClientRect().left;

                let activeIndex = 0;
                let minDiff = Infinity;

                items.forEach((el, i) => {
                    const diff = Math.abs(el.getBoundingClientRect().left - contentLeft);
                    if (diff < minDiff) {
                        minDiff = diff;
                        activeIndex = i;
                    }
                });

                if (activeIndex !== this.currentIndex) {
                    this.setActiveThumb(activeIndex);

                    // ✅ MAIN PAGE THUMB SYNC
                    syncMainThumbnails(activeIndex);
                }
            });
        }


        bindSnapScroll() {
            if (this._snapBound) return;
            this._snapBound = true;

            /* ---------- TOUCH (MOBILE) ---------- */
            let startX = 0;
            let deltaX = 0;
            let touching = false;
            const TOUCH_THRESHOLD = 60;

            this.content.addEventListener("touchstart", (e) => {
                if (this._slideLocked) return;
                if (this.content.querySelector(".zoomable-media.is-zoomed")) return;
                touching = true;
                startX = e.touches[0].clientX;
                deltaX = 0;
                this.content.style.transition = "none";
            }, { passive: true });

            this.content.addEventListener("touchmove", (e) => {
                if (!touching) return;
                deltaX = e.touches[0].clientX - startX;
            }, { passive: true });

            this.content.addEventListener("touchend", () => {
                if (!touching) return;
                touching = false;

                if (Math.abs(deltaX) < TOUCH_THRESHOLD) {
                    this.scrollToIndex(this.currentIndex);
                    return;
                }

                this.scrollToIndex(
                    deltaX < 0 ? this.currentIndex + 1 : this.currentIndex - 1
                );
            });

            /* ---------- WHEEL (DESKTOP) ---------- */
            let wheelLock = false;

            this.content.addEventListener("wheel", (e) => {
                if (this._slideLocked) return;
                e.preventDefault();
                if (wheelLock) return;
                if (this.content.querySelector(".zoomable-media.is-zoomed")) return;

                wheelLock = true;
                this.scrollToIndex(
                    e.deltaY > 0 || e.deltaX > 0
                        ? this.currentIndex + 1
                        : this.currentIndex - 1
                );

                setTimeout(() => wheelLock = false, 400);
            }, { passive: false });
        }

    }

    const customZoom = new CustomZoom();

    function initCustomZoom(container) {
        if (!container) return;

        // 🔧 FIX: collect IMAGE + VIDEO in same DOM order
        const mediaEls = Array.from(
            container.querySelectorAll(".product__media img, .product__media video")
        );

        const mediaArr = mediaEls.map(el => {
            if (el.tagName === "IMG") {
                const src = el.currentSrc || el.src;
                return {
                    type: "image",
                    src: src,
                    poster: src
                };
            } else {
                return {
                    type: "video",
                    src: el.currentSrc || el.src,
                    poster:
                        el.poster ||
                        el.getAttribute("data-poster") ||
                        el.closest(".product__media")?.querySelector("img")?.currentSrc ||
                        ""
                };
            }
        });


        mediaEls.forEach((el, index) => {
            el.style.cursor = "zoom-in";
            el.onclick = () => customZoom.open(index, mediaArr);
        });
    }
    processVariantCustom();
    // -----------------------------
    // ⚡ EVENT BINDINGS
    // -----------------------------
    function initAyaaniProduct() {
        console.log("INIT RUNNING");

        disableShopifyMediaSync();
        initAllSwipers(true);
        observeProductMedia();
        processVariantCustom();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAyaaniProduct);
    } else {
        initAyaaniProduct();
    }

    document.addEventListener("change", (e) => {
        if (e.target.matches(".product__info-wrapper fieldset input[type='radio']")) {
            processVariantFast();                          // 0ms — price + form instant
            clearTimeout(variantTimer);
            variantTimer = setTimeout(processVariantCustom, 300); // 300ms — API + images
        }
    });

    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => initAllSwipers(true), 400);
    });
})();